import { ReputationContainer, ReputationSection, AssetsGrid, SectionTitle, SectionTitleHighlight } from "./styles";
import { REPUTATION_ASSETS } from './constants';

const Reputation = () => {
  return (
    <ReputationSection>
      <ReputationContainer>
        <SectionTitle>
          Reputation&nbsp;
          <SectionTitleHighlight>
            Matters
          </SectionTitleHighlight>
        </SectionTitle>

        <AssetsGrid>
          {REPUTATION_ASSETS.map((asset) => (
            <img 
              key={asset.id}
              src={`https://storage.googleapis.com/cdn.sendspark.com/share/themes/apm/badge-${asset.id}.png`} 
              alt={asset.alt} 
              title={asset.alt} 
            />
          ))}
        </AssetsGrid>
      </ReputationContainer>
    </ReputationSection>
  )
}

export default Reputation;